<template>
  <div class="mt-3" v-if="inspection">
    <div :id="`cover_sheet_${inspection._id}`" class="report sheet sheet-cover border rounded">
      <article class="py-5 bg-white" :class="{ transparent: isLoading }">
        <div class="d-flex w-100 mx-auto header-logo">
          <div class="w-50 text-center p-3 d-flex justify-content-start align-items-center">
            <img src="@/assets/images/tnb-logo-report.png" />
          </div>
          <div class="w-50 text-center p-3 py-3 d-flex justify-content-end align-items-center"
            v-if="inspection.vendor && inspection.vendor.logo">
            <img :src="inspection.vendor.logo.url" />
          </div>
        </div>

        <p class="my-5 px-3 summary-title text-center">
          <!-- CONDITION BASED ASSESSMENT SERVICES USING THERMOGRAPHY -->
          <span v-if="reportType == 'Defect' && defectType != 'All'">{{ defectType }}</span>
          {{ reportType || 'FULL' }} REPORT
        </p>

        <!-- <p class="font-weight-bold text-center mb-4">
          THERMO DEFECT SCANNING REPORT MVOH
        </p>
        <p class="font-weight-bold text-center mb-1">
          DISTRIBUTION NETWORK TNB
        </p>
        <p class="font-weight-bold text-center mb-5">
          DISTRIBUTION MAINTENANCE SBU
        </p> -->

        <table class="table table-borderless mb-0 mx-auto" style="width: fit-content;">
          <tbody>
            <tr>
              <td>FEEDER</td>
              <td>:</td>
              <td>{{ inspection.place && inspection.place.name }}</td>
            </tr>
            <tr>
              <td>SECTION</td>
              <td>:</td>
              <td></td>
            </tr>
            <tr>
              <td>STATE</td>
              <td>:</td>
              <td>{{ reportState }}</td>
            </tr>
            <tr>
              <td>PO NO</td>
              <td>:</td>
              <td>{{ inspection.poNo }}</td>
            </tr>
            <tr>
              <td>DATE INSPECTION</td>
              <td>:</td>
              <td>{{ dateFormat('date', inspection.date) }}</td>
            </tr>
            <tr>
              <td>EQUIPMENT</td>
              <td>:</td>
              <td>{{ inspection.equipement }}</td>
            </tr>
            <tr>
              <td>TESTER</td>
              <td>:</td>
              <td>{{ inspection.tester }}</td>
            </tr>
            <tr>
              <td>REPORTER</td>
              <td>:</td>
              <td>{{ inspection.reporter }}</td>
            </tr>
            <tr>
              <td class="align-top">VENDOR</td>
              <td class="align-top">:</td>
              <td>
                <p class="mb-0">{{ inspection.vendor && inspection.vendor.name }}</p>
                <p class="mb-0 text-wrap" style="max-width: 75vh;">
                  {{ inspection.vendor && inspection.vendor.address }}
                </p>
              </td>
            </tr>
          </tbody>
        </table>

      </article>
      <loading-spinner class="loading-spinner-component" v-if="isLoading"></loading-spinner>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: "reportSheetCover",
  props: [
    "inspection",
    "reportType",
    "defectType"
  ],
  components: {
    "loading-spinner": LoadingSpinner,
  },
  data() {
    return {
      isLoading: false
    };
  },
  watch: {
    inspection: {
      async handler() {
        if (this.inspection) {
          this.resizeSummarySheet();
        }
      },
      immediate: true,
    },
  },
  computed: {
    reportState() {
      return this.inspection?.place?.place?.place?.state;
    },
  },
  methods: {
    dateFormat(type, date) {
      if (date) {
        if (type === "date") {
          return moment.utc(date).format("DD/MM/YYYY");
        } else if (type === "time") {
          return moment.utc(date).format("h:mm A");
        } else {
          return date;
        }
      } else {
        return "";
      }
    },
    resizeSummarySheet(skipTimeout) {
      this.isLoading = skipTimeout ? false : true;
      setTimeout(
        () => {
          let elementId = `#cover_sheet_${this.inspection._id}`;
          const sheet = $(elementId);
          const sheetWidth = sheet.width();
          sheet.height(sheetWidth * 1.2414285714);
          sheet.css({
            fontSize: sheetWidth * 0.01526119403,
          });
          const title = sheet
            .children()
            .children(".summary-title");
          title.css({
            fontSize: sheetWidth * 0.03,
          });
          this.isLoading = false;
        },
        skipTimeout ? 10 : 2000
      );
    },
    getRowClass(severity) {
      let result;

      switch (severity?.toLowerCase()) {
        case "low":
          result = "bg-low";
          break;
        case "minor":
          result = "bg-normal";
          break;
        case "cautious":
          result = "bg-minor";
          break;
        case "critical":
          result = "bg-critical";
          break;
        default:
          result = "bg-light";
          break;
      }

      return result;
    },
  },
  mounted() {
    $(window).on("resize", (e) => {
      this.resizeSummarySheet(true);
    });
  },
  beforeDestroy() {
    $(window).off("resize");
  },
};
</script>

<style lang="scss" scoped>
@import url("../assets/css/print.scss");

.bg-gray {
  background-color: #f5f7fa !important;
}

.sheet {
  width: 100% !important;
  height: auto;
  position: relative;

  article {
    width: 100%;
    height: 100%;
    display: block;
    padding-inline: 15mm;

    .header-logo {
      div {
        img {
          object-fit: contain;
          height: 100%;
          max-width: 75%;
        }
      }
    }

    .summary-title {
      font-size: 3.5rem;
      font-weight: 600;
      text-transform: uppercase;
    }

    &.transparent {
      opacity: 0;
    }

    table tr {

      td {
        padding-block: 0.25rem !important;
      }

      td:first-child,
      td:nth-child(2) {
        font-weight: 600 !important;
        width: 1% !important;
      }

      td:last-child {
        text-transform: uppercase;
      }
    }
  }
}
</style>
